import {writable} from "svelte/store"

// export const backofficeServiceHost = "http://localhost:8081"

const calculateHost = () => {
    const split = document.URL.split("/")
    return `${split[0]}//backoffice-service.${split[2].split(".").splice(1).join(".")}`
}

export const backofficeServiceHost = calculateHost()

export function uuidv4() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}

export const balanceMap = writable()
export const balanceSelected = writable()

export const userRef = writable()
